import { axios1 as axios } from '../../axios'

export default {
  async fetchDataDisposisiTerbaru({ commit }) {
    const data = await axios.get('/dashboard/disposisi-terbaru')
    commit('SET_DISPOSISI_TERBARU', data.data)
  },
  async fetchDataRatingPerbidang({ commit }) {
    const data = await axios.get('/dashboard/rating-perbidang')
    commit('SET_RATING_PERBIDANG', data.data)
  },
  async fetchDataRatingTerbaru({ commit }) {
    const data = await axios.get('/dashboard/rating-terbaru')
    commit('SET_RATING_TERBARU', data.data)
  },
  async fetchDataKinerja({ commit }, params) {
    const data = await axios.get('/dashboard/kinerja', { params })
    commit('SET_KINERJA', data.data)
  },
  async fetchDataStatistikIzin({ commit }) {
    const data = await axios.get('/dashboard/statistik-izin')
    commit('SET_STATISTIK_IZIN', data.data)
  },
  async fetchGrafikPermohonan({ commit }, params) {
    const data = await axios.get('/dashboard/data-permohonan', { params })
    commit('SET_GRAFIK_PERMOHONAN', data.data)
  },
  async fetchGrafikPermohonanPerbidang({ commit }, params) {
    const data = await axios.get('/dashboard/permohonan-perbidang', { params })
    commit('SET_GRAFIK_PERMOHONAN_PERBIDANG', data.data)
  },
  async fetchGrafikVerifikasiPerbidang({ commit }, params) {
    const data = await axios.get('/dashboard/permohonan-verifikasi-perbidang', {
      params
    })
    commit('SET_GRAFIK_VERIFIKASI_PERBIDANG', data.data)
  },
  async fetchGrafikPermohonanPerbulan({ commit }, params) {
    const data = await axios.get('/dashboard/permohonan-perbulan', { params })
    commit('SET_GRAFIK_PERMOHONAN_PERBULAN', data.data)
  },
  async fetchGrafikPermohonanPerbulanGenap({ commit }, params) {
    const data = await axios.get('/dashboard/permohonan-perbulan', { params })
    commit('SET_GRAFIK_PERMOHONAN_PERBULAN_GENAP', data.data)
  },
  async fetchGrafikSelesaiPerbidang({ commit }, params) {
    const data = await axios.get('/dashboard/permohonan-selesai-perbidang', { params })
    commit('SET_GRAFIK_PERMOHONAN_SELESAI_PERBIDANG', data.data)
  },
  async fetchGrafikPermohonanPerminggu({ commit }) {
    const data = await axios.get('/dashboard/permohonan-perminggu')
    commit('SET_GRAFIK_PERMOHONAN_PERMINGGU', data.data)
  }
}
